import { BaseModel } from "../base.model";

export interface VideoCategory extends BaseModel {
    level?: number;
    name?: string;
    parentCategory?: any[],
    children?: any
}

export const defaultVideoCategory: Readonly<VideoCategory> = {};